module.exports = __webpack_public_path__ + "img/Celine.ba5677bb.jpeg";